/**
 * Catálogos y helpers del codificador REJAS.
 * Compartido entre codification-rejas.vue (genera nombres) y rejas-filters.vue (filtra documentos).
 * Si se añade una opción nueva, se refleja automáticamente en ambos sitios.
 */

export const REJAS_PREFIX = 'DREJ'

// ---- CODIFICADOR 1 (Planos): Disciplinas (1 letra) ----
export const c1Disciplinas = [
  { code: 'C', description: 'Civil' },
  { code: 'P', description: 'Proceso' },
  { code: 'G', description: 'General' },
  { code: 'A', description: 'Medio Ambiente' },
  { code: 'J', description: 'Planificación' },
  { code: 'T', description: 'Tuberías' },
  { code: 'M', description: 'Equipos' },
  { code: 'E', description: 'Electricidad' },
  { code: 'I', description: 'Instrumentación y Control' },
]

// ---- CODIFICADOR 1 (Planos): Tipos de documento (1 letra) ----
export const c1TiposDocumento = [
  { code: 'P', description: 'Proceso' },
  { code: 'O', description: 'Otros' },
  { code: 'M', description: 'Implantación' },
  { code: 'H', description: 'Topografía' },
  { code: 'K', description: 'Medio Ambiente' },
  { code: 'V', description: 'Expropiaciones' },
  { code: 'J', description: 'Montaje' },
  { code: 'T', description: 'Tuberías' },
  { code: 'E', description: 'Redes Auxiliares' },
  { code: 'A', description: 'Arquitectura' },
  { code: 'F', description: 'Formas' },
  { code: 'X', description: 'Sistemas Auxiliares' },
  { code: 'L', description: 'Detalles' },
  { code: 'B', description: 'Simbología' },
  { code: 'D', description: 'Diagramas' },
  { code: 'W', description: 'Esquemas cableado' },
  { code: 'Y', description: 'Lógica control' },
  { code: 'N', description: 'Maqueta' },
]

// ---- CODIFICADOR 2 (Resto): Creadores (3 letras) ----
export const c2Creadores = [
  { code: 'UTE', description: 'UTE' },
  { code: 'ATC', description: 'Asistencia Técnica' },
  { code: 'DOB', description: 'Dirección de Obra' },
  { code: 'DGE', description: 'Drace' },
  { code: 'DRA', description: 'Dragados' },
  { code: 'A&P', description: 'Allies & Partners' },
  { code: 'PUJ', description: 'Prefabricados Pujol' },
  { code: 'PAV', description: 'Prefabricados Paver' },
  { code: 'AHI', description: 'Ahijones' },
  { code: 'AMA', description: 'Amaexco' },
  { code: 'C.T.C', description: 'C.T.C' },
  { code: 'CEM', description: 'Cemex' },
  { code: 'EJI', description: 'El Ejidillo' },
  { code: 'JSA', description: 'Jesus Santos' },
  { code: 'ALG', description: 'Algaperi' },
  { code: 'LOG', description: 'Logística Ambiental' },
  { code: 'PEN', description: 'Peninsular de Residuos' },
  { code: 'RES', description: 'Rescan' },
  { code: 'SAL', description: 'Salmedina' },
  { code: 'TRA', description: 'Transanc Salmedina' },
  { code: 'TRY', description: 'Tryobsa' },
]

// ---- CODIFICADOR 2 (Resto): Tipos de documento (3 letras) ----
export const c2TiposDocumento = [
  { code: 'MED', description: 'Mediciones' },
  { code: 'LAB', description: 'Laboratorio' },
  { code: 'INF', description: 'Informes' },
  { code: 'ETE', description: 'Especificaciones' },
  { code: 'ACT', description: 'Actas' },
  { code: 'GRL', description: 'General' },
  { code: 'CLC', description: 'Cálculos' },
  { code: 'CER', description: 'Certificado' },
]

// ---- CODIFICADOR 2 (Resto): Disciplinas (3 letras) ----
export const c2Disciplinas = [
  { code: 'ELE', description: 'Electricidad' },
  { code: 'MEC', description: 'Mecánicas' },
  { code: 'OCV', description: 'Obra Civil' },
  { code: 'CTE', description: 'Control Económico' },
  { code: 'MAB', description: 'Medio Ambiente' },
  { code: 'CAL', description: 'Calidad' },
  { code: 'ARQ', description: 'Arquitectura' },
  { code: 'GRL', description: 'General' },
  { code: 'PRO', description: 'Proceso' },
]

// Abecedario para revisiones
export const abecedary = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

/**
 * Genera opciones de año: actual +/- 2 años
 * @param {function} momentFn - instancia de moment
 * @returns {Array<{value: string, name: string}>}
 */
export function getYearValues(momentFn) {
  let options = []
  ;[-2, -1, 0, 1, 2].forEach(function(index) {
    let year = momentFn().add(index, 'year')
    options.push({ value: year.format('YY'), name: year.format('YYYY') })
  })
  return options
}

/**
 * Arma los params que se envían al backend para filtrar por codificación rejas.
 * Usado en el Buscador de documentos (búsqueda global vía API).
 *
 * Estructura del nombre codificado:
 *   Planos: {year}-DREJ-{disc}D{tipo}-{nro}-{desc}-R{letter}
 *   Resto:  {year}-DREJ-{creador}-{tipo}-{disc}-{nro}-{desc}-R{letter}
 */
export function buildRejasFilterParams(filters) {
  const params = {}

  if (filters.rejas_year) {
    params.rejas_year = filters.rejas_year
  }

  if (filters.rejas_revision) {
    params.rejas_revision = filters.rejas_revision
  }

  // Con codificador seleccionado se arma el patrón LIKE completo (ej: "26-DREJ-UTE-ETE-MEC-%-%-%")
  if (filters.rejas_codificador) {
    const year = filters.rejas_year || '%'
    const number = filters.rejas_number
      ? filters.rejas_number.toString().padStart(3, '0')
      : '%'
    const desc = filters.rejas_descripcion || '%'
    const revision = filters.rejas_revision ? 'R' + filters.rejas_revision : 'R%'

    let parts = []

    if (filters.rejas_codificador === 'planos') {
      const disc = filters.rejas_c1_disciplina || '_'
      const tipo = filters.rejas_c1_tipo_documento || '_'
      parts = [year, REJAS_PREFIX, disc + 'D' + tipo, number, desc, revision]
    } else {
      const creador = filters.rejas_c2_creador || '%'
      const tipo = filters.rejas_c2_tipo_documento || '%'
      const disc = filters.rejas_c2_disciplina || '%'
      parts = [year, REJAS_PREFIX, creador, tipo, disc, number, desc, revision]
    }

    params.rejas_pattern = parts.join('-')
  }

  return params
}

/**
 * Comprueba si el nombre de un documento coincide con los filtros rejas.
 * Usado para filtrado client-side en vistas Carpetas y Contenedor.
 * Compara contra original_filename (ej: "26-DREJ-UTE-ETE-MEC-007-DESC-RA.pdf").
 * Documentos sin patrón DREJ quedan excluidos automáticamente.
 */
export function matchesRejasFilters(docName, filters) {
  if (!docName) return false

  const name = docName.replace(/\.[^.]+$/, '') // quitar extensión
  const parts = name.split('-')

  // Si no tiene estructura DREJ mínima, no es documento codificado rejas
  if (parts.length < 3 || parts[1] !== REJAS_PREFIX) return false

  if (filters.rejas_year && parts[0] !== filters.rejas_year) return false

  // Revisión siempre es el último segmento: "RA", "RB", etc.
  if (filters.rejas_revision) {
    const lastPart = parts[parts.length - 1]
    if (lastPart !== 'R' + filters.rejas_revision) return false
  }

  if (!filters.rejas_codificador) return true

  if (filters.rejas_codificador === 'planos') {
    // En planos, parts[2] junta disciplina+D+tipo en un bloque (ej: "CDP" = Civil+D+Proceso)
    if (parts.length >= 3 && parts[2].length >= 3 && parts[2][1] === 'D') {
      if (filters.rejas_c1_disciplina && parts[2][0] !== filters.rejas_c1_disciplina) return false
      if (filters.rejas_c1_tipo_documento && parts[2][2] !== filters.rejas_c1_tipo_documento) return false
    } else if (filters.rejas_c1_disciplina || filters.rejas_c1_tipo_documento) {
      return false
    }
  } else {
    // En resto, cada campo va en su propia posición: creador-tipo-disciplina
    if (filters.rejas_c2_creador && (parts.length < 3 || parts[2] !== filters.rejas_c2_creador)) return false
    if (filters.rejas_c2_tipo_documento && (parts.length < 4 || parts[3] !== filters.rejas_c2_tipo_documento)) return false
    if (filters.rejas_c2_disciplina && (parts.length < 5 || parts[4] !== filters.rejas_c2_disciplina)) return false
  }

  return true
}
